module.exports = __webpack_public_path__ + "img/15.ed169db8.jpg";